export const uuidv4 = () => crypto.randomUUID();

// number 0 to 1
export const randomNumber = () => crypto.getRandomValues(new Uint32Array(1))[0] / (Math.pow(2, 32) - 1);
